import React, { useState, useContext, useEffect } from "react";

import LargeCard from "sub_components/Common/LargeCard";
import { BloxButton } from "styled_components/Common/BloxButton";
import { ServiceRequestGA } from "blox_components/Support/ServiceRequest/ServiceRequestGA";
import { ServiceRequestRH } from "blox_components/Support/ServiceRequest/ServiceRequestRH";
import { ServiceRequestContext } from "context/ServiceRequestContext";
import { UserProfileApi } from "services/userProfile";
import InfoModal from "sub_components/Common/InfoModal";
import add from "date-fns/add";

const CDN_URL = process.env.REACT_APP_CDN_URL;
const remoteHands = `${CDN_URL}common/remote_hands_image.svg`;
const guestAccess = `${CDN_URL}common/guest_access_image.svg`;
const REQUEST_DETAILS = {
  REMOTE_HANDS: {
    title: "Remote Hands",
    description: "How can we assist with your data center needs?",
    image: remoteHands,
    className: "remote-hands",
  },
  GUEST_ACCESS: {
    title: "Guest Access",
    description: "Tell us who's coming to service your equipment.",
    image: guestAccess,
    className: "guest-access",
  },
};

const ServiceRequest = ({
  type,
  breakpoint,
  tickets,
  company_info,
  auth_status,
  setModalContent,
  navigate,
  location,
  ticketType,
  updateTickets,
  pages,
}) => {
  const { title, description, image, className } = REQUEST_DETAILS[type];
  const { change } = useContext(ServiceRequestContext);
  const [showModal, setShowModal] = useState(false);
  const [showInfoModal, setShowInfoModal] = useState(false);
  const [services, setServices] = useState([]);

  const getServices = async () => {
    const {
      customer: { id },
    } = company_info;
    const { organizationServices } =
      await new UserProfileApi().getCompanyServices(id);

    setServices(organizationServices);
  };

  function setShowModalInfo() {
    setShowInfoModal(true);
  }

  useEffect(() => {
    getServices();
  }, []);

  const SubmitButton = (
    <BloxButton
      className="buttons41"
      id={type === "REMOTE_HANDS" ? "remote-hands" : "guest-access"}
      text="REQUEST"
      module="support"
      enabled={true}
      onClick={() => setShowModal(true)}
      cypressId={type === "REMOTE_HANDS" ? "remote-hands" : "guest-access"}
    />
  );

  function resetModal() {
    change({ target: { name: "description", value: "" } });
    change({ target: { name: "title", value: "" } });
    change({ target: { name: "location", value: "" } });
    change({ target: { name: "podNumber", value: "" } });
    change({ target: { name: "cabNumber", value: "" } });
    change({ target: { name: "name", value: "" } });
    change({ target: { name: "email", value: "" } });
    change({ target: { name: "phone", value: "" } });
    change({ target: { name: "contactPreference", value: "" } });
    change({
      target: { name: "startDateTime", value: add(new Date(), { days: 1 }) },
    });
    change({
      target: { name: "endDateTime", value: add(new Date(), { days: 1 }) },
    });
    change({ target: { name: "duration", value: { value: 60, label: "1h" } } });
    change({ target: { name: "attendees", value: "" } });
    change({ target: { name: "rulesAcknowledged", value: false } });
    change({ target: { name: "timeSelected", value: false } });
    change({ target: { name: "durationSelected", value: false } });
    change({ target: { name: "review", value: false } });
    change({ target: { name: "submitted", value: false } });
    change({ target: { name: "type", value: "" } });
    change({ target: { name: "priority", value: "" } });
    change({ target: { name: "attendees", value: [] } });
    change({ target: { name: "clearance", value: null } });
    change({ target: { name: "guest", value: "" } });
    setShowModal(false);
    setShowInfoModal(false);
  }

  return (
    <div className="advanced-request">
      <LargeCard
        title={title}
        button={SubmitButton}
        description={description}
        image={image}
        customClass={className}
        onClick={() => {}}
        cypressId={
          type === "REMOTE_HANDS"
            ? "remote-hands-component"
            : "guest-access-component"
        }
        id={
          type === "REMOTE_HANDS"
            ? "remote-hands-component"
            : "guest-access-component"
        }
      />
      {type === "GUEST_ACCESS" && (
        <ServiceRequestGA
          navigate={navigate}
          breakpoint={breakpoint}
          closeModal={resetModal}
          showModal={showModal}
          tickets={tickets}
          pages={pages}
          company_info={company_info}
          auth_status={auth_status}
          setModalContent={setModalContent}
          location={location}
          services={services}
          ticketType={ticketType}
          updateTickets={updateTickets}
          setShowInfoModal={setShowModalInfo}
        />
      )}
      {type === "REMOTE_HANDS" && (
        <ServiceRequestRH
          navigate={navigate}
          breakpoint={breakpoint}
          tickets={tickets}
          closeModal={resetModal}
          showModal={showModal}
          pages={pages}
          company_info={company_info}
          auth_status={auth_status}
          setModalContent={setModalContent}
          location={location}
          services={services}
          ticketType={ticketType}
          updateTickets={updateTickets}
          setShowInfoModal={setShowModalInfo}
        />
      )}
      <InfoModal
        success={false}
        customErrorTitle="Alert"
        open={showInfoModal}
        error="Your request is within 24 hours. It may take up to 4 hours for our support team to respond to your request."
      />
    </div>
  );
};

export default ServiceRequest;
